<template>
  <div>
    <template v-if="entity">
      <span v-if="withoutLink">{{ entity.name }}</span>

      <template v-else>
        <template v-if="worker">
          <template v-if="newPage">
            <a target="_blank" :href="`?r=redesign#/personal-employee/${worker.id}/${link ? link : 'summary'}`">
              {{ worker.name }}
            </a>
          </template>
          <template v-else>
            <router-link
              v-if="worker"
              target="_blank"
              :to="{
                name: 'personal-employee-summary',
                params: { id: worker.id },
              }"
            >
              {{ worker.name }}
            </router-link>
          </template>
        </template>

        <template v-else>
          <span>{{ user.name ? user.name : (user.username ? user.username : "") }}</span>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: ["value", "withoutLink", "newPage", "link"],
  computed: {
    worker() {
      return this.value && this.value.worker;
    },
    user() {
      return this.value && this.value.user;
    },
    entity() {
      return this.worker || this.user;
    },
  },
};
</script>
